export default "__VITE_ASSET__DYNqoHO8__"